import * as yup from 'yup';
import {
  addressSchemaShape,
  dssValidationSchema,
} from '../CreateSigningAppointment/01_detailsStep/detailsForm/hooks/useDetailsValidationSchema';
import { addressValidation } from '../CreateSigningAppointment/01_detailsStep/detailsForm/hooks/util/addressValidation';

export const AppointmentEditFormValidationSchema = yup.object().shape(
  {
    ...dssValidationSchema,
    status: yup.string().required(),
    address: yup
      .object()
      .when(
        ['isSignatureSyncAppointment', 'isDigitalScheduling', 'signerWillProvideLocation', 'isDigitalSchedulingDraft'],
        {
          is: (
            isSigSync?: boolean,
            isDigSync?: boolean,
            signerWillProvideLocation?: boolean,
            isDigitalSchedulingDraft?: boolean
          ) => addressValidation(isSigSync, isDigSync, signerWillProvideLocation, isDigitalSchedulingDraft),
          then: yup.object().shape(addressSchemaShape).required().typeError('Address is required'),
          otherwise: yup.object().nullable().notRequired(),
        }
      ),
  },
  [['appointmentDate', 'appointmentTime']]
);
